<template>
    <div style="background-color: #f2f2f2;height: 100%;">
        <div style="background-color: #fff;padding:0px 20px; line-height: 50px;border-bottom: 1px solid #ddd;">
            订单评价
        </div>
        <div style="padding: 20px;">
            <div>
                <el-row>
                    <div style="float:right" v-if="zoneValue.length>0">
                        <el-cascader
                        
                            placeholder="请选择所属地区"
                            v-model="zoneCode"
                            :options="zoneValue"
                            :props="zoneProps"
                            style="margin:0 10px">
                        </el-cascader>
                        <el-button style="margin-left:10px;float:right" type="primary" icon="el-icon-search" @click="getList(true)">搜索</el-button>
                    </div>
                </el-row>

                <div style="clear: both;"></div>
            </div>

            <div style="height: 10px;"></div>

            <div>
                <template>

                    <el-table :data="tableData" :height="th" border style="width: 100%;">
                        <el-table-column prop="user.name" label="评价人" width="100"></el-table-column>
                        <el-table-column prop="user.phone" label="手机号" width="120"></el-table-column>
                        <!-- <el-table-column prop="elderlyDTO.zoneName" label="所属区域" width="300"></el-table-column> -->
                        
                        <el-table-column prop="createTime" :formatter="timefilter" width="200" label="创建时间"></el-table-column>
                        <el-table-column prop="orderBusiness.price" label="订单价格" width="150"></el-table-column>
                        <!-- <el-table-column
                                prop="orderBusiness.isSchedule"
                                :formatter="isSchedules"
                                label="预订单">
                        </el-table-column> -->
                        <el-table-column
                                prop="orderBusiness.orderType"
                                :formatter="statusTitle"
                                label="订单类型" width="150">
                        </el-table-column>
                        <el-table-column
                                prop="orderBusiness.status"
                                :formatter="statuss"
                                label="订单状态"
                                width="150">
                        </el-table-column>
                        <el-table-column prop="remarks" label="评价内容" ></el-table-column>

                        <el-table-column fixed="right" label="操作" width="200">
                            <template slot-scope="scope">
                                <el-button type="primary" size="mini" @click="handleInfo(scope.$index, scope.row)">详情</el-button>
                            </template>
                        </el-table-column>

                    </el-table>

                    <div style="text-align: left;background-color: #fff;padding: 10px;">
                        <div style="float: left;padding: 5px;">共{{totalItems}}条（{{Math.ceil(totalItems/pageSize)}}页）</div>
                        <div style="float: left;">
                            <el-pagination
                                    background
                                    layout="prev, pager, next"
                                    :total="totalItems"
                                    :page-size="20"
                                    :current-page.sync="currentPage"  @current-change="current_change">
                            </el-pagination>
                        </div>
                        <div style="clear: both;"></div>
                    </div>


                </template>
            </div>

        </div>

        <AppraiseInfo ref="myAppraiseInfo" v-show="showModalAppraiseInfo" v-bind:goodsClassValue="goodsClassValue" v-on:closeAppraiseInfo="closeAppraiseInfo" v-on:getList="getList"></AppraiseInfo>
        <!-- <Edit ref="myEdit" v-show="showModalEdit" v-bind:goodsClassValue="goodsClassValue" v-on:closeEdit="closeEdit" v-on:getList="getList"></Edit> -->

    </div>
</template>

<script>

    import {timeStr,timefilters} from "@/common/times";
    import {hex_md5} from "@/common/Base64MD5";

    // import Edit from "./Edit";
    import AppraiseInfo from "./AppraiseInfo";
    import {getStaffCode} from "@/utils/auth";

    export default {
        name: "Role",
        data(){
            return{
                loading:false,
                showModalAppraiseInfo:false,
                tableData:null,
                goodsClassCode:'',
                name:null,
                businessCode:'',
                totalItems: 0,
                pageSize:20,
                currentPage:1,
                th:0,
                goodsClassValue:[],
                zoneCode:'00000000-0000-0000-0000-000000000000',
                zoneValue:[],
                zoneProps:{
                    emitPath:false,
                    value: 'zoneCode',
                    // 显示的文字字段名
                    label: 'name',
                    // 子层级字段名
                    children: 'listZoneDTO'
                },
            }
        },
        components:{
            AppraiseInfo
        },
        created(){
            this.init();
            this.getList();
            this.th = this.$store.state.tableHeight;
        },

        watch: {
            //监听全局变量
            '$store.state.tableHeight' : function(val){
                console.log(val);
                this.th = val;
            },
        },
        methods:{
            init(){
                this.$axios({
                    method: 'post',
                    url: this.$shopUrl+"Zone/ListForStaff",
                    data: {
                        timeStr:timeStr,
                        sign:hex_md5("timeStr=" + timeStr + "&key="+this.$signKey),
                        staffCode: getStaffCode(),
                    }
                }).then( (response)=> {
                    console.log(response);
                    if(response.data.error == 0){
                        var data=JSON.stringify(response.data.data);
                        data=JSON.parse(data.replace(/"listZoneDTO":\[\],/g,''))
                        this.zoneValue = data;
                    }else if(response.data.error == 1){
                        this.$message.error(response.data.message)
                    }
                })
                // var level=getStaffDTO().zoneDTO.level
            },
            //日期格式
            timefilter(row, column, cellValue){
                return timefilters(cellValue)
            },

            current_change:function(currentPage){
                this.currentPage = currentPage;
                this.getList();
            },
            
            handleInfo:function(index,row){
                this.showModalAppraiseInfo = !this.showModalAppraiseInfo;
                this.$refs.myAppraiseInfo.init(row);
            },
            closeAppraiseInfo:function(){
                this.showModalAppraiseInfo = !this.showModalAppraiseInfo;
            },
            getList(isSearch){
                if(isSearch)this.currentPage=1
                this.$axios({
                    method: 'post',
                    url: this.$shopUrl+"OrderBusinessAppraise/GetJWHAndJDPageList",
                    data: {
                        timeStr:timeStr,
                        sign:hex_md5("timeStr=" + timeStr + "&key="+this.$signKey),
                        staffCode: getStaffCode(),
                        zoneCode:this.zoneCode,
                        // businessCode:this.businessCode,
                        pageIndex:this.currentPage,
                        pageSize:this.pageSize,
                    }
                }).then( (response)=> {
                    console.log(response);
                    if(response.data.error == 0){
                        this.tableData = response.data.data.list;
                        this.totalItems = response.data.data.total;
                    }else if(response.data.error == 1){
                            this.$message.error(response.data.message)
                        }
                }).catch(function (error) {
                    console.log(error);
                });
            },
            statusTitle(row, column, cellValue){
                 return this.allStatus(cellValue,["",'普通商品订单','社会化服务订单','政府购买服务订单']);
            },
            isSchedules(row, column, cellValue){
                 return this.allStatus(cellValue,['否','是']);
            },
            statuss(row, column, cellValue){
                return this.allStatus(cellValue,['待付款','待发货','待收货','交易成功','退款中','交易关闭','交易取消','已评价',"","",'待付款','待接单','已接单','服务中','服务完成','交易取消','已评价']);
            },
            allStatus(row,status){
                for(var i in status){
                    if(i==row){
                        return status[i]
                    }
                }
                return "其它";
            }



        }
    }
</script>

<style scoped>

</style>
